const COUNTRY_DATA = {
  Afghanistan: { dialCode: "93", iso2: "af" },
  Albania: { dialCode: "355", iso2: "al" },
  Algeria: { dialCode: "213", iso2: "dz" },

  // === +1 region (ONLY US enabled) ===
  "United States": { dialCode: "1", iso2: "us" },

  // American Samoa: { dialCode: "1", iso2: "as" },
  Andorra: { dialCode: "376", iso2: "ad" },
  Angola: { dialCode: "244", iso2: "ao" },

  // Anguilla: { dialCode: "1", iso2: "ai" },
  Antarctica: { dialCode: "672", iso2: "aq" },

  // Antigua and Barbuda: { dialCode: "1", iso2: "ag" },

  Argentina: { dialCode: "54", iso2: "ar" },
  Armenia: { dialCode: "374", iso2: "am" },
  Aruba: { dialCode: "297", iso2: "aw" },
  Australia: { dialCode: "61", iso2: "au" },
  Austria: { dialCode: "43", iso2: "at" },
  Azerbaijan: { dialCode: "994", iso2: "az" },

  // Bahamas: { dialCode: "1", iso2: "bs" },
  Bahrain: { dialCode: "973", iso2: "bh" },
  Bangladesh: { dialCode: "880", iso2: "bd" },

  // Barbados: { dialCode: "1", iso2: "bb" },

  Belarus: { dialCode: "375", iso2: "by" },
  Belgium: { dialCode: "32", iso2: "be" },

  // Bermuda: { dialCode: "1", iso2: "bm" },

  Bhutan: { dialCode: "975", iso2: "bt" },
  Bolivia: { dialCode: "591", iso2: "bo" },
  "Bosnia and Herzegovina": { dialCode: "387", iso2: "ba" },
  Botswana: { dialCode: "267", iso2: "bw" },
  Brazil: { dialCode: "55", iso2: "br" },
  Brunei: { dialCode: "673", iso2: "bn" },
  Bulgaria: { dialCode: "359", iso2: "bg" },

  // Burkina Faso: { dialCode: "226", iso2: "bf" },
  Burundi: { dialCode: "257", iso2: "bi" },

  Cambodia: { dialCode: "855", iso2: "kh" },
  Cameroon: { dialCode: "237", iso2: "cm" },

  // Canada: { dialCode: "1", iso2: "ca" },

  "Cape Verde": { dialCode: "238", iso2: "cv" },

  // Cayman Islands: { dialCode: "1", iso2: "ky" },

  "Central African Republic": { dialCode: "236", iso2: "cf" },
  Chad: { dialCode: "235", iso2: "td" },
  Chile: { dialCode: "56", iso2: "cl" },
  China: { dialCode: "86", iso2: "cn" },

  // Dominica: { dialCode: "1", iso2: "dm" },
  // Dominican Republic: { dialCode: "1", iso2: "do" },

  Egypt: { dialCode: "20", iso2: "eg" },
  France: { dialCode: "33", iso2: "fr" },
  Germany: { dialCode: "49", iso2: "de" },
  India: { dialCode: "91", iso2: "in" },
  Indonesia: { dialCode: "62", iso2: "id" },
  Ireland: { dialCode: "353", iso2: "ie" },
  Italy: { dialCode: "39", iso2: "it" },
  Japan: { dialCode: "81", iso2: "jp" },
  Malaysia: { dialCode: "60", iso2: "my" },
  Mexico: { dialCode: "52", iso2: "mx" },
  Netherlands: { dialCode: "31", iso2: "nl" },
  Nigeria: { dialCode: "234", iso2: "ng" },
  Pakistan: { dialCode: "92", iso2: "pk" },
  'Saudi Arabia': { dialCode: "966", iso2: "sa" },
  Singapore: { dialCode: "65", iso2: "sg" },
  'South Africa': { dialCode: "27", iso2: "za" },
  'South Korea': { dialCode: "82", iso2: "kr" },
  Spain: { dialCode: "34", iso2: "es" },
  Sweden: { dialCode: "46", iso2: "se" },
  Switzerland: { dialCode: "41", iso2: "ch" },
  Thailand: { dialCode: "66", iso2: "th" },
  Turkey: { dialCode: "90", iso2: "tr" },
  'United Kingdom': { dialCode: "44", iso2: "gb" },
  Vietnam: { dialCode: "84", iso2: "vn" },
};

export const COUNTRIES = Object.entries(COUNTRY_DATA)
  .map(([name, { dialCode, iso2 }]) => ({
    name,
    dialCode,
    flag: iso2
      ? `https://flagcdn.com/24x18/${iso2}.png`
      : null,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

export const getCountryMatch = (fullPhone = "") => {
  const defaultCountry =
    COUNTRIES.find((c) => c.name === "United States") || COUNTRIES[0];

  const phone = fullPhone.replace(/\D/g, "");

  const matches = COUNTRIES
    .filter((c) => phone.startsWith(c.dialCode))
    .sort((a, b) => b.dialCode.length - a.dialCode.length);

  const country = matches.length
    ? matches.find((c) =>
        c.dialCode === "1"
          ? ["United States", "Canada"].includes(c.name)
          : true
      ) || matches[0]
    : defaultCountry;

  return {
    country,
    national: phone.slice(country.dialCode.length),
  };
};